import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import { _addNotification, _addNotificationError, getModuleEnum, getAccessLevelByModule, isRegularLunchOrderType } from "../../../server/util";
import { get, postWithHeadersResponse, postWithHeaders } from '../../../server/actions';
import { URL_VERSION } from '../../../server/constants';
import DateTimeRangePicker from '../../Misc/DateTimeRangePicker';
import Doughnut from './DashboardCharts/orderDoughnut';
import OrderLine from './DashboardCharts/orderLine';
import ItemHBar from './DashboardCharts/ItemHBar';
import NegBalChart from './DashboardCharts/NegBalChart';
import BalTrund from './DashboardCharts/BalTrund';
import OrderNotOrder from './DashboardCharts/OrderVsNotorder';
import BalAmtByGrade from './DashboardCharts/BalAmtByGrade';
import FreeReduceRegularChart from './DashboardCharts/FreeReduceRegularChart';
import HouseHoldAppAlert from '../../Misc/setupLoading/houseHoldAppAlert'
import FoodContactAlert from '../../Misc/setupLoading/foodContactAlert'
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import RadioMenu from '../../Misc/MenuOptions/radioMenu';
import { getReportMenuOptions } from '../../Misc/MenuOptions/menuOptionsActions';
import { MealTypesReports } from '../../../server/constants';
import DirectCertificationAlert from './DashboardCharts/DirectCertificationAlert';
var _ = require('lodash');
let loginUserInfo = {};
const modalStyles = {
    content: {
        top: '35%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

class schoolAdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            createSchoolYear: false,
            schoolYearList: [],
            mealType: (getReportMenuOptions()[0] || ''),
            schoolYearRec: {
                sessionStartDateTime: moment(),
                sessionEndDateTime: moment(),
                copySettings: false
            },
            selectedSchoolYear: { name: '', schoolYear: '' },
            activeMonth: sessionStorage.getItem('activeMonth')
        }
        this.validateSchoolYear = this.validateSchoolYear.bind(this);
        this.getActiveMonth = this.getActiveMonth.bind(this);
        this.onSchoolYearSave = this.onSchoolYearSave.bind(this);
    }

    componentWillMount = () => {
        if ((sessionStorage.getItem('schoolYear') || '') === '') {
            this.validateSchoolYear();
        }
        else {
            let selectedSchoolYear = this.state.selectedSchoolYear;
            selectedSchoolYear.name = sessionStorage.getItem('schoolYear')
            selectedSchoolYear.schoolYear = sessionStorage.getItem('schoolYearValue')
            this.setState({ selectedSchoolYear: selectedSchoolYear, schoolYearList: JSON.parse(sessionStorage.getItem('schoolYearsList')) });
        }
        loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));

    }
    componentDidMount = () => {
        const { schoolYearList, schoolYearRec } = this.state
        this._notificationSystem = this.refs.notificationSystem;
        const sortedSchoolYears = (Object.values(schoolYearList) || []).sort((a, b) => Number(a.schoolYears) - Number(b.schoolYears));
        const latestRec = sortedSchoolYears.length > 0 ? sortedSchoolYears[sortedSchoolYears.length - 1] : {};
        schoolYearRec.sessionStartDateTime = moment(latestRec.sessionEndDateTime).isValid() ? moment(latestRec.sessionEndDateTime).add('d', 1) : moment();
        schoolYearRec.schoolActualStartDate = moment(latestRec.sessionEndDateTime).isValid() ? moment(latestRec.sessionEndDateTime).add('d', 1) : moment();
        schoolYearRec.sessionEndDateTime = moment(latestRec.sessionEndDateTime).isValid() ? moment(latestRec.sessionEndDateTime).add('y', 1) : moment();
        this.setState({ schoolYearRec: { ...schoolYearRec } });
    }
    validStartDate = (currentDate) => {
        const { schoolYearList } = this.state;
        const sortedSchoolYears = (Object.values(schoolYearList) || []).sort((a, b) => Number(a.schoolYears) - Number(b.schoolYears));
        let latestRec = sortedSchoolYears.length > 0 ? sortedSchoolYears[sortedSchoolYears.length - 1] : undefined;
        if (!latestRec) {
            latestRec = {};
            latestRec.sessionStartDateTime = moment();
            latestRec.sessionEndDateTime = moment();
        }

        return currentDate > (moment(latestRec.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss').isValid() ? moment(latestRec.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss') : moment());
    }
    validEndDate = (currentDate) => {
        const { schoolYearRec } = this.state;
        return currentDate > moment(schoolYearRec.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss');
    }

    handleSchoolYearChange = (e) => {
        console.log('evt', e.target.value)
        let selectedSchoolYear = this.state.selectedSchoolYear
        selectedSchoolYear.name = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
        selectedSchoolYear.schoolYear = e.target.value;
        //console.log('evt',document.getElementById("schoolYear").value)
        sessionStorage.setItem('schoolYear', e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text);
        sessionStorage.setItem('schoolYearValue', e.target.value);
        this.setState({ selectedSchoolYear: selectedSchoolYear }, this.getActiveMonth());
    }
    validateSchoolYear = (isRebind = false) => {
        get('/schoolYears/search/findByMealSchoolSchoolId?mealSchoolId=' + sessionStorage.getItem("SchoolId") + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {

            if (data._embedded.schoolYears.length === 0) {
                if (!isRebind) {
                    // this.setState({ modalIsOpen: true });
                }
            }
            else {
                sessionStorage.setItem('schoolYearsList', JSON.stringify(data._embedded.schoolYears));
                const schoolYearList = data._embedded.schoolYears.map((item) => {
                    return {
                        ...item,
                        sessionStartDateTime: moment.utc(item.sessionStartDateTime, 'YYYY-MM-DDThh:mm:ss').local().format('YYYY-MM-DDThh:mm:ss'),
                        sessionEndDateTime: moment.utc(item.sessionEndDateTime, 'YYYY-MM-DDThh:mm:ss').local().format('YYYY-MM-DDThh:mm:ss')
                    }
                });
                let rec = _.filter(schoolYearList, function (o) {
                    const stDate = moment(moment(o.sessionStartDateTime, 'YYYY-MM-DDThh:mm:s')).startOf('day');
                    const nowDate = moment().toDate();
                    const endDate = moment(moment(o.sessionEndDateTime, 'YYYY-MM-DDThh:mm:s')).endOf('day');
                    return (stDate <= nowDate && endDate >= nowDate);
                });
                if (rec.length === 0 && (sessionStorage.getItem('schoolYear') || '') === '') {
                    // this.setState({ modalIsOpen: true });
                } else {
                    let selectedSchoolYear = this.state.selectedSchoolYear;
                    selectedSchoolYear.name = rec[0].name;
                    selectedSchoolYear.schoolYear = rec[0].schoolYear
                    sessionStorage.setItem('schoolYear', rec[0].name),
                        sessionStorage.setItem('schoolYearValue', rec[0].schoolYear)
                    this.setState({ selectedSchoolYear: selectedSchoolYear });
                }
                this.setState({ schoolYearList: data._embedded.schoolYears });
            }
        }).catch(
            (error) => {
                console.log('Get School data response', error)
            }
        );
    }
    onSchoolYearSave = () => {
        let schoolYearRec = this.state.schoolYearRec;
        if (moment(schoolYearRec.sessionStartDateTime) > moment(schoolYearRec.sessionEndDateTime)) {
            _addNotificationError('End date must greater than start date.', this);
            return false;
        }
        let sd = moment(schoolYearRec.sessionStartDateTime).startOf('D');
        let ed = moment(schoolYearRec.sessionEndDateTime).endOf('D');
        let reqObj = {
            name: moment(schoolYearRec.sessionStartDateTime).utc().format("YYYY") + '-' + moment(schoolYearRec.sessionEndDateTime).utc().format("YYYY"),
            loggedUser: sessionStorage.getItem('loggedUserName'),
            mealSchool: '/mealManage/mealSchools/' + sessionStorage.getItem("SchoolId"),
            schoolYear: moment(schoolYearRec.sessionStartDateTime).utc().format("YYYY"),
            sessionStartDateTime: moment(sd).utc().format("YYYY-MM-DDTHH:mm:ss"),
            sessionEndDateTime: moment(ed).utc().format("YYYY-MM-DDTHH:mm:ss"),
            sisLoad: schoolYearRec.sisLoad == true ? true : false
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        this.setState({ loading: true });


        postWithHeaders('/schoolYears/?access_token=', JSON.stringify(reqObj), headers)
            .then((response) => {
                if (response.ok) {
                    this.validateSchoolYear(true);
                    _addNotification('School year created successfully.', this);
                    this.setState({ loading: false, createSchoolYear: false });
                    console.log('response', response);
                } else {
                    throw Error(response.statusText);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false, createSchoolYear: false });
                    _addNotificationError(error.message, this);
                    console.log('Meal Menu Creation Error', error)
                }
            );
    }
    getActiveMonth = () => {
        get(URL_VERSION + '/latestActiveMenuMonth?mealSchoolId=' + sessionStorage.getItem("SchoolId") + '&schoolYearVal=' + sessionStorage.getItem('schoolYearValue') + '&access_token=')
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                if ((data.activeMenuMonth || '') === '') {
                    let idx = this.state.schoolYearList.findIndex((sYear) => {
                        return sYear.schoolYear == sessionStorage.getItem('schoolYearValue');
                    })
                    if (idx !== -1) {
                        let yearMonth = moment(this.state.schoolYearList[idx].sessionStartDateTime).local().format('YYYYMM');
                        sessionStorage.setItem('activeMonth', yearMonth);
                        this.setState({ activeMonth: yearMonth })
                    } else {
                        sessionStorage.setItem('activeMonth', moment().format('YYYYMM'))
                        this.setState({ activeMonth: moment().format('YYYYMM') })
                    }


                } else {
                    sessionStorage.setItem('activeMonth', data.activeMenuMonth)
                    this.setState({ activeMonth: data.activeMenuMonth })
                }


            }).catch((error) => {
                console.log('Get School data response', error)
            })
    }


    render() {
        const modEnum = getModuleEnum();
        const _loggedInUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        const stripeAcceptance = _loggedInUserInfo.stripeAcceptance == null ? undefined : _loggedInUserInfo.stripeAcceptance
        const stripeAccountId = _loggedInUserInfo.stripeAccountId == null ? undefined : _loggedInUserInfo.stripeAccountId
        const isPaymentEnable = _loggedInUserInfo.isPaymentEnable == null ? undefined : _loggedInUserInfo.isPaymentEnable
        const isPrimaryAdmin = _loggedInUserInfo.isPrimaryAdmin == null ? undefined : _loggedInUserInfo.isPrimaryAdmin
        return (
            <section className="full-width clearfix">

                <NotificationSystem ref="notificationSystem" />
                <div className="container">
                    <FoodContactAlert isShowAlert={(loginUserInfo.isContactDetailsReq == undefined ? true : loginUserInfo.isContactDetailsReq)} />
                    {
                        getAccessLevelByModule(modEnum.LETM) ?
                            <HouseHoldAppAlert schoolId={sessionStorage.getItem("SchoolId")} schoolYear={sessionStorage.getItem('schoolYearValue')} /> : null
                    }
                    <DirectCertificationAlert
                        districtId={0}
                        schoolId={sessionStorage.getItem("SchoolId")}
                        schoolYear={sessionStorage.getItem('schoolYearValue')}
                        self={this}
                    />


                    <div className="sectionTitle">
                        <h2>
                            <div className="row">
                                <div className="col-xs-12">
                                    <label className="col-xs-6 text-left" style={{ paddingLeft: '0px' }}>Admin Dashboard</label>
                                    {/*  <div  className="col-xs-4" style={{display:'inline-block'}}>
                            <MenuOptions menuOptionsList={getReportMenuOptions()} onOptionSelect={(type)=>{
                                          this.setState({mealType:type},()=>{
                                            ''
                                          })
                                    }} selectedOption={(this.state.mealType)} />
                                   
                                    </div> */}
                                    <label className="col-xs-4 text-right">School Year: </label>
                                    <select className="col-xs-2" id={"schoolYear"} value={this.state.selectedSchoolYear.schoolYear}
                                        onChange={e => this.handleSchoolYearChange(e)}>
                                        <option disabled selected value>School Year</option>
                                        {this.state.schoolYearList.map(function (value, key) {

                                            return <option key={key}
                                                value={value.schoolYear}>{value.name}</option>
                                        }, this)}
                                    </select>
                                </div>
                            </div>
                        </h2>
                    </div>
                    <div className="row school-admin-dashboard">
                        <OrderLine mealType={this.state.mealType} schoolYear={sessionStorage.getItem('schoolYearValue')} onElementClick={(grade, action, selectedMonthYear) => {
                            this.context.router.history.push('/schoolAdmin/viewOrdersGrid/' + action + '/' + grade + '/' + selectedMonthYear + '/' + this.state.mealType);
                        }} />
                        <Doughnut mealType={this.state.mealType} activeMonth={this.state.activeMonth == 'null' ? undefined : this.state.activeMonth}
                            schoolYear={this.state.selectedSchoolYear.schoolYear} onElementClick={(grade, action, selectedMonthYear) => {
                                this.context.router.history.push('/schoolAdmin/viewOrdersGrid/' + action + '/' + grade + '/' + selectedMonthYear);
                            }} />
                        <ItemHBar mealType={this.state.mealType} activeMonth={this.state.activeMonth == 'null' ? undefined : this.state.activeMonth} />

                        <NegBalChart schoolYear={sessionStorage.getItem('schoolYearValue')} onElementClick={(grade, action, selectedMonthYear) => {
                            this.context.router.history.push('/schoolAdmin/managePayments/' + action + '/' + grade + '/' + selectedMonthYear);
                        }} />
                        <BalTrund
                            //activeMonth={this.state.activeMonth=='null'?undefined:this.state.activeMonth} 
                            activeMonth={moment().format('YYYYMM')}
                            schoolYear={this.state.selectedSchoolYear.schoolYear}
                            onElementClick={(payType, action, from, to) => {
                                //this.context.router.history.push('/schoolAdmin/paymentReports?opr='+action+'&from='+from+'&to='+to);
                                this.context.router.history.push('/schoolAdmin/financialReport?opr=' + action + '&from=' + from + '&to=' + to);
                            }} />

                        <OrderNotOrder mealType={this.state.mealType} activeMonth={this.state.activeMonth == 'null' ? undefined : this.state.activeMonth} onElementClick={(grade, action, selectedMonthYear) => {
                            this.context.router.history.push('/schoolAdmin/viewOrdersGrid/' + action + '/' + grade + '/' + selectedMonthYear);
                        }} />

                        <BalAmtByGrade schoolYear={sessionStorage.getItem('schoolYearValue')} onElementClick={(grade, action, selectedMonthYear) => {
                            this.context.router.history.push('/schoolAdmin/managePayments/' + action + '/' + grade + '/' + selectedMonthYear);
                        }} />
                        {
                            getAccessLevelByModule(modEnum.LETM) ?
                                <FreeReduceRegularChart schoolYear={sessionStorage.getItem('schoolYearValue')} /> : null
                        }



                    </div>
                </div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.setState({ modalIsOpen: false })}
                    style={modalStyles}
                    contentLabel="Activation"
                    shouldCloseOnOverlayClick={false}
                    ariaHideApp={false}
                >
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">School year</h4>
                    </div>
                    <div className="modal-body">
                        <form name="frmPay" className="">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor="ddSchoolYear">Please Select Previous School Year or Create New School Year</label>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <div className="col-md-7">
                                            <select className="form-control" name="ddSchoolYear" value={this.state.selectedSchoolYear.schoolYear} onChange={
                                                (e) => {
                                                    let selectedSchoolYear = this.state.selectedSchoolYear;

                                                    selectedSchoolYear.name = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
                                                    selectedSchoolYear.schoolYear = e.target.value;
                                                    this.setState({ selectedSchoolYear: selectedSchoolYear });
                                                }
                                            } >
                                                <option disabled selected value=''>School Year</option>
                                                {
                                                    this.state.schoolYearList.map(item => {
                                                        return (
                                                            <option key={item.id} value={item.schoolYear}>
                                                                {item.name}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>

                                        </div>
                                        <div className="col-md-5">
                                            <button type="button" className="btn btn-xs btn-warning" style={{ margin: '0px' }} onClick={() => {
                                                this.setState({ 'createSchoolYear': true })
                                            }}>Create New School Year</button>

                                        </div>
                                    </div>
                                    {
                                        this.state.createSchoolYear ? (
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-12 col-md-12">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <label className="color-3">Create New School Year</label>
                                                        </div>
                                                    </div>
                                                    <div className="row form-group">
                                                        <div className=" col-xs-12 col-sm-12 col-md-6">
                                                            <label htmlFor="ddSchoolYearfrom">From :</label>
                                                            <Datetime style={{ margin: '0px' }} id="fromDate" timeFormat={false}
                                                                value={this.state.schoolYearRec.sessionStartDateTime}
                                                                isValidDate={this.validStartDate}
                                                                onChange={(e) => {
                                                                    let schoolYearRec = this.state.schoolYearRec;
                                                                    schoolYearRec.sessionStartDateTime = moment(e)
                                                                    this.setState({ schoolYearRec: schoolYearRec })
                                                                }}
                                                                locale='en-US'
                                                                closeOnSelect />
                                                        </div>
                                                        <div className=" col-xs-12 col-sm-12 col-md-6">
                                                            <label htmlFor="ddSchoolYearfrom">To :</label>
                                                            <Datetime id="toDate" timeFormat={false}
                                                                value={this.state.schoolYearRec.sessionEndDateTime}
                                                                isValidDate={this.validEndDate}
                                                                onChange={(e) => {
                                                                    let schoolYearRec = this.state.schoolYearRec
                                                                    schoolYearRec.sessionEndDateTime = moment(e)
                                                                    this.setState({ schoolYearRec: schoolYearRec })
                                                                }}
                                                                locale='en-US'
                                                                closeOnSelect />
                                                        </div>
                                                    </div>
                                                    <div className='row form-group'>
                                                        <div className='col-sm-12'>
                                                            <div className="checkbox">
                                                                <label>
                                                                    <input name="sisLoad" className='chbox' checked={this.state.schoolYearRec.sisLoad} type="checkbox" onChange={(e) => {
                                                                        let _schoolYear = this.state.schoolYearRec;
                                                                        _schoolYear.sisLoad = e.target.checked
                                                                        this.setState({ schoolYearRec: _schoolYear });

                                                                    }} /> Import students using SIS load
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row form-group'>
                                                        <div className='col-sm-12 text-center'>
                                                            <p style={{ fontSize: '12px', marginLeft: '30px' }}>
                                                                <b>Note: </b>
                                                                <span>
                                                                    Previous school year all settings will be copied to new school year, you can modify them anytime by updating school year.
                                                                </span>
                                                            </p>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="form-group col-xs-12 col-sm-12 col-md-12">
                                                            <button type="button" className="btn btn-primary btn-xs  pull-right" style={{ margin: '0' }}
                                                                onClick={() => { this.setState({ createSchoolYear: false }) }}><i
                                                                    className="glyphicon glyphicon-remove"
                                                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                                            </button>
                                                            <button type="button" className="btn btn-success btn-xs pull-right" style={{ marginLeft: 0, marginRight: '10px', marginTop: 0 }}
                                                                onClick={() => { this.onSchoolYearSave() }}><i
                                                                    className="fa fa-floppy-o"
                                                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>) : null
                                    }
                                </div>





                            </div>
                        </form>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs pull-left" style={{ margin: '0' }}
                            onClick={() => {
                                // console.log('this', this.context.router.history)
                                let request = new Promise((resolve) => (get('/logout?access_token=').then(response => {
                                    console.log('resp', response);
                                    if (!response.ok || response.ok) {
                                        resolve(sessionStorage.clear());
                                    }
                                })));

                                Promise.resolve(request).then(() => {
                                    //  console.log('this', this.context.router.history);
                                    //this.context.router.history.push({pathname: '/login'});
                                    window.location.replace('/login');// redirect to login
                                });
                            }}> Cancel

                        </button>
                        <button type="button" className="btn btn-success btn-xs" style={{ margin: 0 }}
                            onClick={() => {
                                let selectedSchoolYear = this.state.selectedSchoolYear
                                if ((selectedSchoolYear.name || '').trim() === '') {
                                    _addNotificationError('Select School Year.', this)
                                }
                                else {
                                    sessionStorage.setItem('schoolYear', selectedSchoolYear.name);
                                    sessionStorage.setItem('schoolYearValue', selectedSchoolYear.schoolYear);
                                    this.setState({ modalIsOpen: false })
                                }
                            }}> Submit
                        </button>

                    </div>

                </Modal>
            </section>

        );
    }
}
schoolAdminDashboard.contextTypes = {
    router: PropTypes.object.isRequired
}

export default schoolAdminDashboard;




// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/dashBoard.jsx